export default __webpack_public_path__ + "static/media/trng-rt.58c1e335.png";